export function calculateAmount(pricePerUnit, numberOfItems, markupFactor) {
    return pricePerUnit * numberOfItems * (1 + (markupFactor ?? 0) / 100);
}
export function calculateAmountWithoutMarkup(pricePerUnit, numberOfItems) {
    return pricePerUnit * numberOfItems;
}
